import React from 'react';

/** Label with any trailing "(…)" drawn lighter than the label itself. */
export function taskDetailsFieldLabel(label: string): React.ReactNode {
  const match = /^(.*?)\s*(\([^)]*\))\s*$/.exec(label);
  if (!match || !match[1]) return label;
  return React.createElement(
    React.Fragment,
    null,
    match[1],
    ' ',
    React.createElement(
      'span',
      { style: { color: 'var(--mantine-color-dimmed)', fontWeight: 400 } },
      match[2],
    ),
  );
}

export function formatTaskTypeLabel(value: string | null | undefined): string {
  if (!value) return '';
  return String(value)
    .trim()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((w) => `${w.charAt(0).toUpperCase()}${w.slice(1).toLowerCase()}`)
    .join(' ');
}

export { formatDependencyFieldLabel, resolveTaskWbsCode } from '../../../gantt/taskLinkDisplayUtils';

export const taskDetailsReadOnlyFieldStyles = {
  input: {
    backgroundColor: 'var(--mantine-color-default-hover)',
    color: 'var(--mantine-color-dimmed)',
    fontWeight: 400,
    opacity: 1,
    WebkitTextFillColor: 'var(--mantine-color-dimmed)',
    '&::placeholder': {
      color: 'var(--mantine-color-placeholder)',
      fontWeight: 400,
      opacity: 1,
      WebkitTextFillColor: 'var(--mantine-color-placeholder)',
    },
  },
};
export const taskDetailsCompactLabelProps = { style: { fontSize: 11, fontWeight: 500 } };
